import React from "react";
import Panel from "../layout/Panel";
import PlaceholderContent from "../layout/PlaceholderContent";
import Spacer from "../layout/Spacer";
import {Spinner} from "../Iconset";
import FileUploadPercent from "../filebrowser/FileUploadPercent";

type ProjectLoadingDialogProps = {
	message?: string;
	secondMessage?: string | React.ReactElement | null;
	staticWidth: boolean;
};

export const ModalProgressDialog: React.FC<ProjectLoadingDialogProps> = ({ message, secondMessage, staticWidth }) =>
{
	return (
		<Panel className="waitMessageRoot">
			<PlaceholderContent staticWidth={staticWidth}>
				{message ? (
					<>
						<div className="largeText">{message}</div>
						<Spacer size={{ y: '12px' }} />
					</>
				) : null}
				<Spinner />
				<Spacer size={{ y: '12px' }} />
				<div className="largeText">
					{!secondMessage ? <FileUploadPercent /> : secondMessage}
				</div>
			</PlaceholderContent>
		</Panel>
	);
};

